import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { AuthProvider } from './Components/AuthContext/AuthContext';
import ToastProvider from './ToastProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import Store from './ReduxStore/Store';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
  <AuthProvider>
    <ToastProvider>
      <Provider store={Store}>
        <Router>
          <App />
        </Router>
      </Provider>
    </ToastProvider>
  </AuthProvider>
  </HelmetProvider>
);

reportWebVitals();

